import {
  $post, $get, $JsonPost, vte,
} from '@/utils/axios-request';


class Test {
  // 通过学生编号和课程编号查询试卷题目详情
  public async getByStudentCourseId(postData: any): Promise<any> {
    return await $get(`${vte}/userTest/api/v1/getByUserCourseId`, postData);
  }

  // 保存学生的答题结果
  public async saveStudentTestResult(postData: any): Promise<any> {
    return await $post(`${vte}/userTest/api/v1/saveUserTestResult`, postData);
  }

  // 检查是否需要测试
  public async getCheckIsNeedTest(postData: any): Promise<any> {
    return await $get(`${vte}/userTest/api/v1/getCheckIsNeedTest`, postData);
  }

  // 通过测试试卷编号查询试卷详情
  public async getStudentTestById(postData: any): Promise<any> {
    return await $get(`${vte}/userTest/api/v1/getUserTestById`, postData);
  }

  // 获取用户试卷
  public async getUserExamination(postData: any): Promise<any> {
    return await $get(`${vte}/Examination/api/v1/getUserExamination`, postData);
  }

  // 获取用户试卷
  public async saveUserExamination(postData: any): Promise<any> {
    return await $post(`${vte}/Examination/api/v1/saveUserExamination`, postData);
  }
}
export default new Test();
